import * as types from "./actionsTypes";

export function setNotifications(notifs) {
    return {
        type: types.SET_NOTIFICATIONS,
        data: notifs
    }
}
